__turbopack_context__.v({
  "back": "style-module-scss-module__5k89Fa__back",
  "badge": "style-module-scss-module__5k89Fa__badge",
  "body": "style-module-scss-module__5k89Fa__body",
  "container": "style-module-scss-module__5k89Fa__container",
  "container__isFlipped": "style-module-scss-module__5k89Fa__container__isFlipped",
  "face": "style-module-scss-module__5k89Fa__face",
  "outerTariff": "style-module-scss-module__5k89Fa__outerTariff",
  "outerTariff__smallWidth": "style-module-scss-module__5k89Fa__outerTariff__smallWidth",
  "placements": "style-module-scss-module__5k89Fa__placements",
  "placementsWarning": "style-module-scss-module__5k89Fa__placementsWarning",
  "placementsWarning__disabled": "style-module-scss-module__5k89Fa__placementsWarning__disabled",
  "placementsWarning__title": "style-module-scss-module__5k89Fa__placementsWarning__title",
});
